/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import Cookies from 'cookies-js'

import Request from 'generic/request/Request'

import * as applicantActions from 'actions/Applicant'
import * as constants from 'constants/Login'
import * as userConstants from 'constants/User'
import * as applicantConstants from 'constants/Applicant'

const LOGIN_URL = '/api/login/'
const LOGOUT_URL = '/api/logout/'
const CONNECTED_USER_URL = '/api/connected/user/'
const INTERPRETER_URL = '/api/interpreter/'
const PAYING_CUSTOMER_URL = '/api/paying/customer/'
const CONTACT_URL = '/api/contact/'

export function login (username, password) {
  return Request.postRequest(LOGIN_URL, {
    username: username,
    password: password
  })
    .then(() => {
      Cookies.set('isLogged', true)
    })
    .catch((error) => {
      throw error
    })
}

function getInterpreterInformation(uid) {
  return Request.getRequest(INTERPRETER_URL + uid + '/')
    .then((interpreter) => {
      const identity = interpreter.data.object.identities[0]

      const identityName = identity
        ? identity.first_name + ' ' + identity.last_name.toUpperCase()
        : undefined

      return {
        identityName,
      }
    })
}

function getApplicantInformation(uid) {
  return applicantActions.getApplicant(uid)
    .then((applicant) => {
      const identity = applicant.identities[0]
      const entity = applicant.entities[0]

      const identityName = identity
        ? identity.first_name + ' ' + identity.last_name.toUpperCase()
        : entity.name

      return {
        identityName,
        entityName: entity.name,
        newPrestationAccess: applicant.can_create_prestation,
      }
    })
}

function getPayingCustomerInformation(uid) {
  return Request.getRequest(PAYING_CUSTOMER_URL + uid + '/')
    .then((payingCustomer) => {
      const entity = payingCustomer.data.object.entities[0]

      return {
        identityName: entity.name,
        entityName: entity.name,
      }
    })
}

export function setUserInformation() {
  return async function (dispatch) {
    const roleInformationGetters = {
      [constants.INTERPRETER_ROLE]: getInterpreterInformation,
      [constants.APPLICANT_ROLE]: getApplicantInformation,
      [constants.PAYING_CUSTOMER_ROLE]: getPayingCustomerInformation,
    }
    const userObj = await getUserInformation()
    const role = userObj.roles[0]

    const userInformation = {
      uid: userObj.uid,
      is_staff: userObj.is_staff,
      paymentAccess: userObj.payment_access,
      applicantListAccess: userObj.applicant_list_access,
      viewType: userObj.prestation_list_type,
      prestationWebrtc: userObj.webrtc_access,
      updatePaidPrestation: userObj.update_paid_prestation,
      initialBeneficiaryNumber: userObj.initial_beneficiary_number,
      role: role.role,
    }

    const getRoleInformation = roleInformationGetters[role.role]
    if (!getRoleInformation) return { success: false }

    const roleInformation = await getRoleInformation(role.uid)

    dispatch({
      type: userConstants.SET_USER,
      value: {
        ...userInformation,
        ...roleInformation,
      },
    })

    return { success: true }
  }
}

export function getUserInformation() {
  return Request.getRequest(CONNECTED_USER_URL)
    .then((result) => {
      return result.data.object
    })
}

export function logout () {
  return Request.getRequest(LOGOUT_URL)
}

export function getContact () {
  return Request.getRequest(CONTACT_URL)
}

export function postContact (contact) {
  return Request.postRequest(CONTACT_URL, contact)
}



// WEBPACK FOOTER //
// ./src/actions/Login.js